import { useConfiguratorTranslations } from '../translations';
import shared from '../configurator.module.scss';

export function FuelChipRow({
	chips,
	activeChip,
	onSelect,
}: {
	chips: string[];
	activeChip: string;
	onSelect: (chip: string) => void;
}) {
	const tr = useConfiguratorTranslations();

	// if (chips.length <= 2) return null;

	return (
		<>
			<div className={shared.filterGroupLabel}>{tr.trimFuelLabel}</div>
			<div className={`${shared.chipRow} mb-4`}>
				{chips.map((chip) => (
					<button
						key={chip}
						className={`${shared.chip} ${
							activeChip === chip ? shared.chipActive : ''
						}`}
						onClick={() => onSelect(chip)}
					>
						{tr.fuelChipLabel(chip)}
					</button>
				))}
			</div>
		</>
	);
}
